// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Retema o Bootstrap 5 com os tokens SoftwarePlus — layout "Razão" (importar DEPOIS de
 * "bootstrap/dist/css/bootstrap.min.css" e de "./nocturne-tokens.css").
 * Troca as custom properties que o Bootstrap 5 já usa internamente (botões/forms/tabelas/modais
 * herdam a paleta sem CSS extra); as classes .nt-* cobrem o que não tem equivalente no Bootstrap
 * (casca, menu lateral, faixa de números, status, gráfico do painel, login).
 * Regras do layout: linhas finas no lugar de sombra, números em mono tabular, uma cor de ação
 * (verde conta) e cores de status reservadas — status sempre com texto, nunca só cor.
 */

:root {
  --bs-body-bg: var(--sp-ground);
  --bs-body-color: var(--sp-ink);
  --bs-body-font-family: var(--sp-font-sans);
  --bs-body-font-size: 14px;
  --bs-emphasis-color: var(--sp-ink);
  --bs-secondary-color: var(--sp-ink-3);
  --bs-tertiary-color: var(--sp-ink-2);
  --bs-secondary-bg: var(--sp-rule-2);
  --bs-tertiary-bg: var(--sp-sunk);

  --bs-primary: var(--sp-accent);
  --bs-primary-rgb: 14, 107, 85;
  --bs-success-rgb: 22, 133, 106;
  --bs-danger-rgb: 163, 36, 27;
  --bs-secondary-rgb: 95, 105, 99;
  --bs-link-color: var(--sp-accent);
  --bs-link-hover-color: var(--sp-accent-hover);
  --bs-link-color-rgb: 14, 107, 85;
  --bs-link-hover-color-rgb: 10, 82, 66;

  --bs-border-color: var(--sp-rule);
  --bs-border-color-translucent: var(--sp-rule);
  --bs-border-radius: var(--radius-sm);
  --bs-border-radius-sm: var(--radius-sm);
  --bs-border-radius-lg: var(--radius-md);
  --bs-border-radius-xl: var(--radius-md);

  --bs-focus-ring-color: rgba(14, 107, 85, 0.2);

  color-scheme: light;
}

html,
body,
#root {
  height: 100%;
}
body {
  margin: 0;
  font-family: var(--sp-font-sans);
  font-size: 14px;
  line-height: 1.45;
  color: var(--sp-ink);
  background: var(--sp-ground);
  -webkit-font-smoothing: antialiased;
}
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: var(--sp-font-sans);
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--sp-ink);
}
:focus-visible {
  outline: 2px solid var(--sp-accent);
  outline-offset: 2px;
}
.text-secondary {
  color: var(--sp-ink-3) !important;
}
.text-danger {
  color: var(--sp-bad) !important;
}
.text-success {
  color: var(--sp-ok) !important;
}

/* números tabulares em mono — todo valor monetário, data e código das telas */
.nt-tabular,
.nt-mono {
  font-family: var(--sp-font-mono);
  font-variant-numeric: tabular-nums;
}

/* ── botões ──
   primário/sucesso = verde conta (ação e Salvar); perigo = vermelho (Cancelar e Excluir);
   secundário = neutro branco com borda (ações de apoio). */
.btn {
  --bs-btn-font-family: var(--sp-font-sans);
  --bs-btn-font-size: 13.5px;
  --bs-btn-font-weight: 500;
  --bs-btn-padding-x: 14px;
  --bs-btn-padding-y: 8px;
  --bs-btn-border-radius: var(--radius-sm);
  --bs-btn-focus-box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.2);
  white-space: nowrap;
}
.btn-sm {
  --bs-btn-font-size: 12.5px;
  --bs-btn-padding-x: 10px;
  --bs-btn-padding-y: 5px;
}
.btn-lg {
  --bs-btn-font-size: 14.5px;
  --bs-btn-padding-y: 11px;
}
.btn-primary,
.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: var(--sp-accent);
  --bs-btn-border-color: var(--sp-accent);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: var(--sp-accent-hover);
  --bs-btn-hover-border-color: var(--sp-accent-hover);
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: var(--sp-accent-hover);
  --bs-btn-active-border-color: var(--sp-accent-hover);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: var(--sp-accent);
  --bs-btn-disabled-border-color: var(--sp-accent);
}
.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: var(--sp-bad);
  --bs-btn-border-color: var(--sp-bad);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: var(--sp-bad-hover);
  --bs-btn-hover-border-color: var(--sp-bad-hover);
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: var(--sp-bad-hover);
  --bs-btn-active-border-color: var(--sp-bad-hover);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: var(--sp-bad);
  --bs-btn-disabled-border-color: var(--sp-bad);
}
.btn-secondary,
.btn-outline-secondary,
.btn-light,
.btn-outline-dark {
  --bs-btn-color: var(--sp-ink);
  --bs-btn-bg: var(--sp-surface);
  --bs-btn-border-color: var(--sp-rule);
  --bs-btn-hover-color: var(--sp-ink);
  --bs-btn-hover-bg: var(--sp-sunk);
  --bs-btn-hover-border-color: #b6beb7;
  --bs-btn-active-color: var(--sp-ink);
  --bs-btn-active-bg: var(--sp-rule-2);
  --bs-btn-active-border-color: #b6beb7;
  --bs-btn-disabled-color: var(--sp-ink-3);
  --bs-btn-disabled-bg: var(--sp-surface);
  --bs-btn-disabled-border-color: var(--sp-rule);
}
.btn-ghost {
  color: var(--sp-ink-2);
  background: transparent;
  border: 0;
  padding-inline: var(--space-2);
}
.btn-ghost:hover {
  background: var(--sp-rule-2);
}

/* ── formulários ── */
.form-control,
.form-select {
  border-color: var(--sp-rule);
  border-radius: var(--radius-sm);
  font-size: 14px;
  color: var(--sp-ink);
  min-height: 38px;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--sp-accent);
  box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.15);
}
.form-control:disabled,
.form-control[readonly],
.form-select:disabled {
  background-color: var(--sp-sunk);
  color: var(--sp-ink-2);
}
.form-label,
.nt-field-label {
  font-size: 12.5px !important;
  font-weight: 600 !important;
  color: var(--sp-ink-2);
}
.nt-field-label {
  display: block;
  margin-bottom: 0.3rem;
}
.form-check-input:checked {
  background-color: var(--sp-accent);
  border-color: var(--sp-accent);
}
.form-check-input:focus {
  border-color: var(--sp-accent);
  box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.15);
}
.nav-link {
  color: var(--sp-ink-2);
}
.nav-link:hover,
.nav-link:focus {
  color: var(--sp-ink);
}
.nav-tabs .nav-link.active {
  color: var(--sp-ink);
  font-weight: 600;
}
.nav-pills .nav-link.active {
  background: var(--sp-ink);
}

/* ── controle segmentado (abas de relatório, filtros rápidos) ── */
.nt-seg {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 3px;
  border: 1px solid var(--sp-rule);
  border-radius: var(--radius-sm);
  background: var(--sp-surface);
}
.nt-seg button {
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font: inherit;
  font-size: 13px;
  color: var(--sp-ink-2);
  cursor: pointer;
  white-space: nowrap;
}
.nt-seg button:hover {
  background: var(--sp-sunk);
}
.nt-seg button.on {
  background: var(--sp-ink);
  color: #fff;
}

/* ── painéis / cards: borda fina, sem sombra ── */
.card,
.nt-card {
  background: var(--sp-surface);
  border: 1px solid var(--sp-rule);
  border-radius: var(--radius-md);
  box-shadow: none;
}
.nt-card-kicker {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--sp-ink-3);
}
.nt-card-title {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.25;
  color: var(--sp-ink);
}
.nt-panel-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  padding: 13px 18px;
  border-bottom: 1px solid var(--sp-rule-2);
}
.nt-panel-head h2 {
  font-size: 14.5px;
  margin: 0;
}
.nt-panel-head .nt-meta {
  font-size: 12.5px;
  color: var(--sp-ink-3);
}
.nt-panel-body {
  padding: 16px 18px;
}

/* ── status: quadradinho de cor + texto (ver StatusTag.tsx) ── */
.nt-st {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  white-space: nowrap;
  color: var(--sp-ink);
}
.nt-st::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: var(--sp-mute);
  flex: none;
}
.nt-st[data-tone="ok"]::before {
  background: var(--sp-ok);
}
.nt-st[data-tone="warn"]::before {
  background: var(--sp-warn);
}
.nt-st[data-tone="info"]::before {
  background: var(--sp-info);
}
.nt-st[data-tone="bad"] {
  color: var(--sp-bad);
  font-weight: 500;
}
.nt-st[data-tone="bad"]::before {
  background: var(--sp-bad);
}
.nt-st[data-tone="off"] {
  color: var(--sp-ink-3);
}
.nt-tag {
  display: inline-block;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--sp-rule-2);
  color: var(--sp-ink-2);
  white-space: nowrap;
}

/* ── tabelas: caixa branca com borda fina, cabeçalho claro, sem zebra, rolagem horizontal ── */
.nt-table-wrap {
  overflow-x: auto;
  overflow-y: hidden;
  background: var(--sp-surface);
  border: 1px solid var(--sp-rule);
  border-radius: var(--radius-md);
}
.nt-table-wrap table,
table.nt-table-fade,
table.nt-table {
  margin-bottom: 0;
  table-layout: fixed;
  --bs-table-bg: transparent;
  --bs-table-striped-bg: transparent;
  --bs-table-hover-bg: #fafbf8;
  --bs-table-color: var(--sp-ink);
  --bs-table-striped-color: var(--sp-ink);
  --bs-table-border-color: var(--sp-rule-2);
}
.nt-table thead th,
.nt-table-fade thead th {
  background: var(--sp-sunk);
  color: var(--sp-ink-2);
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 14px;
  border-bottom: 1px solid var(--sp-rule);
  white-space: nowrap;
}
.nt-table thead th.text-end,
.nt-table-fade thead th.text-end {
  text-align: right;
}
.nt-table thead th.text-center,
.nt-table-fade thead th.text-center {
  text-align: center;
}
.nt-table tbody td,
.nt-table-fade tbody td,
.nt-table tfoot td,
.nt-table-fade tfoot td {
  text-align: left;
  padding: 10px 14px;
  font-size: 13.5px;
  vertical-align: middle;
  border-bottom: 1px solid var(--sp-rule-2);
  overflow: hidden;
  text-overflow: ellipsis;
}
.nt-table tbody td.text-end,
.nt-table-fade tbody td.text-end,
.nt-table tfoot td.text-end,
.nt-table-fade tfoot td.text-end {
  text-align: right;
}
.nt-table tbody td.text-center,
.nt-table-fade tbody td.text-center {
  text-align: center;
}
/* coluna de ações (última): nunca corta os botões — quebra em linha se não couber */
.nt-table tbody td:last-child,
.nt-table-fade tbody td:last-child {
  overflow: visible;
}
.nt-table tbody td:last-child > .d-flex,
.nt-table-fade tbody td:last-child > .d-flex {
  flex-wrap: wrap;
  row-gap: 4px !important;
}
.nt-table tbody tr:last-child td,
.nt-table-fade tbody tr:last-child td {
  border-bottom: 0;
}
.nt-table tbody tr:hover > td,
.nt-table-fade tbody tr:hover > td {
  background: #fafbf8;
}
.nt-table tfoot td,
.nt-table-fade tfoot td {
  background: var(--sp-sunk);
  font-weight: 600;
  border-top: 1px solid var(--sp-rule);
  border-bottom: 0;
}
.nt-table-fade tr.nt-row-late > td {
  background: var(--sp-bad-soft);
}
.nt-sub {
  display: block;
  font-size: 12px;
  color: var(--sp-ink-3);
  overflow: hidden;
  text-overflow: ellipsis;
}
.nt-code {
  font-family: var(--sp-font-mono);
  font-size: 12.5px;
  color: var(--sp-ink-2);
}

/* ── paginação (react-paginate + .pagination nativo): botões separados, ativo em tinta ──
   As custom properties precisam ser redeclaradas em ".pagination" (o bootstrap.min.css já as
   define direto na classe, e a declaração local vence a herdada de :root). */
.pagination {
  --bs-pagination-color: var(--sp-ink-2);
  --bs-pagination-bg: var(--sp-surface);
  --bs-pagination-border-color: var(--sp-rule);
  --bs-pagination-border-radius: var(--radius-sm);
  --bs-pagination-hover-bg: var(--sp-sunk);
  --bs-pagination-hover-color: var(--sp-ink);
  --bs-pagination-hover-border-color: #b6beb7;
  --bs-pagination-focus-color: var(--sp-ink);
  --bs-pagination-focus-bg: var(--sp-sunk);
  --bs-pagination-focus-box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.2);
  --bs-pagination-active-bg: var(--sp-ink);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-border-color: var(--sp-ink);
  --bs-pagination-disabled-color: #a9b0ab;
  --bs-pagination-disabled-bg: var(--sp-surface);
  --bs-pagination-disabled-border-color: var(--sp-rule-2);
  gap: 4px;
  flex-wrap: wrap;
}
.pagination .page-link {
  min-width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  padding: 0 9px;
  margin-left: 0 !important;
  border-radius: var(--radius-sm) !important;
  font-family: var(--sp-font-mono);
  font-size: 12.5px;
  cursor: pointer;
}
.nt-pag {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  color: var(--sp-ink-3);
}

/* ── casca: menu lateral + conteúdo ── */
.nt-app {
  display: flex;
  height: 100vh;
  background: var(--sp-ground);
}
.nt-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.nt-content {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.nt-wrap {
  padding: 28px 32px 40px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 1400px;
}
.nt-page-head h1 {
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}
.nt-page-head p {
  margin: 4px 0 0;
  color: var(--sp-ink-3);
  font-size: 13.5px;
  max-width: 70ch;
}

/* a largura anima entre 236px e 0 (desktop recolhido); o miolo tem largura fixa pra o texto não
   quebrar durante a transição. */
.nt-sidebar {
  flex: none;
  width: 236px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--sp-side);
  color: var(--sp-side-ink);
  transition: width 0.25s ease;
}
.nt-sidebar.collapsed {
  width: 0;
}
.nt-sidebar-inner {
  width: 236px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 18px 0 14px;
}
.nt-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px 18px;
  border-bottom: 1px solid var(--sp-side-line);
  color: #fff;
}
.nt-brand strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.nt-brand small {
  display: block;
  font-size: 12px;
  color: var(--sp-side-muted);
}
.nt-mark {
  width: 34px;
  height: 34px;
  border-radius: 7px;
  background: var(--sp-accent);
  color: #fff;
  font-family: var(--sp-font-mono);
  font-weight: 500;
  font-size: 13px;
  display: grid;
  place-items: center;
  flex: none;
}
.nt-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 16px 12px;
  flex: 1 1;
}
.nt-nav-group {
  display: flex;
  flex-direction: column;
}
/* cabeçalho clicável do grupo (Cadastros, Financeiro, Sistema) — abre/fecha os itens */
.nt-nav-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 38px;
  padding: 0 10px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--sp-side-ink);
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}
.nt-nav-toggle:hover,
.nt-nav-toggle[aria-expanded="true"] {
  background: var(--sp-side-2);
  color: #fff;
}
.nt-nav-toggle .bi {
  font-size: 11px;
  color: var(--sp-side-muted);
}
/* grupo fechado que contém a tela atual: um ponto verde avisa onde você está */
.nt-nav-toggle.has-active[aria-expanded="false"] span::after {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--sp-ok);
  margin-left: 8px;
  vertical-align: middle;
}
.nt-nav-items {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 4px 0 8px 10px;
  margin-left: 10px;
  border-left: 1px solid var(--sp-side-line);
}
.nt-nav-top {
  font-weight: 600;
}
.nt-nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 36px;
  padding: 0 10px;
  border-radius: var(--radius-sm);
  color: var(--sp-side-ink);
  text-decoration: none;
  font-size: 13.5px;
}
.nt-nav-item:hover {
  background: var(--sp-side-2);
  color: #fff;
}
/* item ativo na cor do fundo da página: parece uma aba encaixada no conteúdo */
.nt-nav-item.active {
  background: var(--sp-ground);
  color: var(--sp-ink);
  font-weight: 600;
}
.nt-me {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 12px;
  padding: 12px 8px 0;
  border-top: 1px solid var(--sp-side-line);
}
.nt-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #2c3a33;
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 600;
  flex: none;
}
.nt-me strong {
  display: block;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
}
.nt-me small {
  display: block;
  font-size: 11.5px;
  color: var(--sp-side-muted);
}
.nt-me-out,
.nt-side-close {
  margin-left: auto;
  color: var(--sp-side-ink);
  background: transparent;
  border: 0;
  font-size: 12.5px;
  padding: 8px;
  border-radius: var(--radius-sm);
  cursor: pointer;
}
.nt-me-out:hover,
.nt-side-close:hover {
  background: var(--sp-side-2);
  color: #fff;
}
.nt-side-close {
  display: none;
  width: 44px;
  height: 44px;
  font-size: 18px;
}
.nt-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 18, 14, 0.5);
  z-index: 1040;
}

.nt-topbar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px 20px;
  min-height: 56px;
  padding: 10px 32px;
  border-bottom: 1px solid var(--sp-rule);
  background: var(--sp-surface);
}
.nt-crumb {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  color: var(--sp-ink-3);
  min-width: 0;
}
.nt-crumb strong {
  color: var(--sp-ink);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nt-today {
  margin-left: auto;
  font-family: var(--sp-font-mono);
  font-size: 12.5px;
  color: var(--sp-ink-3);
}
.nt-burger {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: var(--sp-ink);
  font-size: 22px;
  border-radius: var(--radius-sm);
  margin-left: -12px;
  flex: none;
}
.nt-burger:hover {
  background: var(--sp-rule-2);
}

/* abaixo de 768px: menu sai do fluxo e vira gaveta por cima da tela (fecha ao navegar, ver
   AppShell); a barra do topo fica escura com o botão de menu. */
@media (max-width: 767.98px) {
  .nt-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 290px;
    z-index: 1045;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    box-shadow: 12px 0 40px rgba(0, 0, 0, 0.3);
  }
  .nt-sidebar.open {
    transform: none;
  }
  .nt-sidebar-inner {
    width: 290px;
    padding-top: 12px;
  }
  .nt-nav-toggle {
    min-height: 44px;
  }
  .nt-brand {
    padding: 0 8px 12px 20px;
  }
  .nt-side-close {
    display: grid;
    place-items: center;
  }
  .nt-nav-item {
    min-height: 44px;
  }
  .nt-topbar {
    background: var(--sp-side);
    border-bottom: 0;
    padding: 6px 12px;
    color: #fff;
  }
  .nt-burger {
    color: #fff;
    width: 44px;
    height: 44px;
    margin-left: -6px;
  }
  .nt-burger:hover {
    background: var(--sp-side-2);
  }
  .nt-crumb {
    color: #fff;
    font-size: 16px;
  }
  .nt-crumb strong {
    color: #fff;
  }
  .nt-crumb-group,
  .nt-crumb-sep,
  .nt-today {
    display: none;
  }
  .nt-wrap {
    padding: 18px 16px 32px;
  }
  .nt-page-head h1 {
    font-size: 21px;
  }
}

/* ── faixa de números (painel e topo das telas) ── */
.nt-figs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  background: var(--sp-surface);
  border: 1px solid var(--sp-rule);
  border-radius: var(--radius-md);
  overflow: hidden;
}
.nt-fig {
  padding: 15px 20px;
  border-left: 1px solid var(--sp-rule-2);
  margin-left: -1px;
  border-top: 1px solid var(--sp-rule-2);
  margin-top: -1px;
}
.nt-fig-label {
  font-size: 12.5px;
  color: var(--sp-ink-3);
}
.nt-fig-value {
  font-family: var(--sp-font-mono);
  font-variant-numeric: tabular-nums;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.02em;
  margin-top: 3px;
}
.nt-fig-value.bad {
  color: var(--sp-bad);
}
.nt-fig-note {
  font-size: 12px;
  color: var(--sp-ink-3);
  margin-top: 1px;
}

/* ── gráfico de barras agrupadas do painel (recebido x pago) ── */
.nt-legend {
  display: flex;
  gap: 14px;
  font-size: 12.5px;
  color: var(--sp-ink-2);
}
.nt-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.nt-legend i {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
}
.nt-chart {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 10px;
}
.nt-chart-y {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
  margin: -7px 0;
  font-family: var(--sp-font-mono);
  font-size: 11px;
  color: var(--sp-ink-3);
  text-align: right;
}
.nt-chart-plot {
  height: 200px;
  display: grid;
  align-items: end;
  border-bottom: 1px solid var(--sp-ink-3);
  background: repeating-linear-gradient(to top, transparent 0 49px, var(--sp-rule-2) 49px 50px);
}
.nt-chart-group {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 2px;
  height: 100%;
}
.nt-chart-bar {
  width: 22px;
  max-width: 30%;
  border-radius: 4px 4px 0 0;
  min-height: 1px;
}
.nt-chart-x {
  grid-column: 2;
  display: grid;
  font-size: 12px;
  color: var(--sp-ink-3);
  text-align: center;
  padding-top: 7px;
}
.nt-hbar {
  display: grid;
  grid-template-columns: minmax(0, 170px) minmax(0, 1fr) 110px;
  align-items: center;
  gap: 12px;
  font-size: 13.5px;
  padding: 7px 0;
}
.nt-hbar-track {
  height: 8px;
  border-radius: 4px;
  background: var(--sp-rule-2);
  overflow: hidden;
}
.nt-hbar-track i {
  display: block;
  height: 8px;
  border-radius: 4px;
  background: var(--sp-accent);
}
.nt-list-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--sp-rule-2);
}
.nt-list-row:last-child {
  border-bottom: 0;
}
.nt-day {
  font-family: var(--sp-font-mono);
  font-size: 12px;
  color: var(--sp-ink-3);
  width: 52px;
  flex: none;
  line-height: 1.25;
}
.nt-day strong {
  display: block;
  font-size: 17px;
  color: var(--sp-ink);
  font-weight: 500;
}
@media (max-width: 560px) {
  .nt-hbar {
    grid-template-columns: minmax(0, 1fr) 100px;
  }
  .nt-hbar-track {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}

/* ── login: painel escuro + formulário ── */
.nt-login {
  display: flex;
  flex-wrap: wrap;
  min-height: 100vh;
  background: var(--sp-ground);
}
.nt-login-side {
  flex: 1 1 440px;
  background: var(--sp-side);
  color: var(--sp-side-ink);
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 48px;
}
.nt-login-side .nt-brand {
  padding: 0;
  border-bottom: 0;
}
.nt-login-side h1 {
  color: #fff;
  font-size: 34px;
  line-height: 1.15;
  max-width: 15ch;
  letter-spacing: -0.02em;
  margin: 0;
}
.nt-ledger {
  border-top: 1px solid var(--sp-side-line);
  max-width: 440px;
}
.nt-ledger div {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--sp-side-line);
  font-size: 13.5px;
}
.nt-ledger b {
  font-family: var(--sp-font-mono);
  font-size: 12.5px;
  color: #fff;
  font-weight: 500;
}
.nt-login-foot {
  font-size: 12px;
  color: var(--sp-side-muted);
}
.nt-login-main {
  flex: 1 1 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}
.nt-login-card {
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.nt-login-card .form-control {
  min-height: 44px;
}
@media (max-width: 767.98px) {
  .nt-login-side {
    padding: 28px 20px 26px;
    gap: 22px;
  }
  .nt-login-side h1 {
    font-size: 24px;
  }
  .nt-ledger,
  .nt-login-foot {
    display: none;
  }
  .nt-login-main {
    align-items: flex-start;
    padding: 26px 20px;
  }
}

/* ── toast ── */
@keyframes nt-rise-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.nt-toast {
  position: fixed;
  top: 12px;
  right: 12px;
  width: min(340px, calc(100vw - 24px));
  padding: 13px 16px;
  border-radius: var(--radius-md);
  background: var(--sp-ink);
  color: #fff;
  box-shadow: var(--shadow-md);
  font-size: 13.5px;
  animation: nt-rise-in 200ms ease-out;
  z-index: 1080;
}
.nt-toast-mark {
  display: none;
}

/* ── modais centralizadas (react-bootstrap Modal) ── */
.modal {
  --bs-modal-bg: var(--sp-surface);
  --bs-modal-color: var(--sp-ink);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: var(--radius-lg);
  --bs-modal-inner-border-radius: var(--radius-lg);
  --bs-modal-header-padding: 18px 22px 14px;
  --bs-modal-header-border-color: var(--sp-rule-2);
  --bs-modal-padding: 18px 22px;
  --bs-modal-footer-bg: var(--sp-sunk);
  --bs-modal-footer-border-color: var(--sp-rule-2);
  --bs-modal-box-shadow: var(--shadow-lg);
}
.modal-backdrop {
  --bs-backdrop-bg: #15201b;
  --bs-backdrop-opacity: 0.55;
}
.modal-content {
  box-shadow: var(--shadow-lg);
  padding: 0 !important;
}
.modal-title {
  font-family: var(--sp-font-sans) !important;
  font-size: 18px !important;
  font-weight: 600;
}
.modal-footer {
  gap: 8px;
  padding: 13px 22px;
}
.modal-footer > * {
  margin: 0;
}
/* o cabeçalho é claro: o X "white" (closeVariant) ficaria invisível */
.modal .btn-close-white {
  filter: none;
}
.nt-dialog .modal-content {
  animation: nt-rise-in 180ms ease-out;
}

/* ── grids de 2 colunas (painel, relatórios) empilham em telas estreitas ── */
.nt-grid-2 {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  align-items: start;
}
.nt-grid-2-even {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
}
@media (max-width: 1020px) {
  .nt-grid-2,
  .nt-grid-2-even {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── menu suspenso (ex.: "Ações" da linha de contrato) ── */
.dropdown-menu {
  --bs-dropdown-border-color: var(--sp-rule);
  --bs-dropdown-border-radius: var(--radius-md);
  --bs-dropdown-box-shadow: var(--shadow-md);
  --bs-dropdown-font-size: 13.5px;
  --bs-dropdown-link-color: var(--sp-ink);
  --bs-dropdown-link-hover-bg: var(--sp-sunk);
  --bs-dropdown-link-active-bg: var(--sp-rule-2);
  --bs-dropdown-link-active-color: var(--sp-ink);
  --bs-dropdown-item-padding-y: 7px;
  --bs-dropdown-divider-bg: var(--sp-rule-2);
  box-shadow: var(--shadow-md);
}
`, "",{"version":3,"sources":["webpack://./src/assets/bootstrap-theme.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,0CAA0C;EAC1C,yBAAyB;EACzB,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;;EAEhC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,6CAA6C;EAC7C,gCAAgC;EAChC,qCAAqC;;EAErC,iCAAiC;EACjC,6CAA6C;EAC7C,oCAAoC;EACpC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;;EAEvC,6CAA6C;;EAE7C,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;AACA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;;EAEE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;2DAE2D;AAC3D;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,wCAAwC;EACxC,2DAA2D;EAC3D,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;;EAEE,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,0BAA0B;EAC1B,yCAAyC;EACzC,mDAAmD;EACnD,2BAA2B;EAC3B,0CAA0C;EAC1C,oDAAoD;EACpD,6BAA6B;EAC7B,sCAAsC;EACtC,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;EACtC,gDAAgD;EAChD,2BAA2B;EAC3B,uCAAuC;EACvC,iDAAiD;EACjD,6BAA6B;EAC7B,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;;;;EAIE,6BAA6B;EAC7B,8BAA8B;EAC9B,qCAAqC;EACrC,mCAAmC;EACnC,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;EACxC,uCAAuC;EACvC,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA;;;EAGE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kDAAkD;AAClD;;EAEE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA,oFAAoF;AACpF;;EAEE,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;6EAE6E;AAC7E;EACE,sCAAsC;EACtC,qCAAqC;EACrC,4CAA4C;EAC5C,+CAA+C;EAC/C,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,wCAAwC;EACxC,kEAAkE;EAClE,wCAAwC;EACxC,kCAAkC;EAClC,kDAAkD;EAClD,uCAAuC;EACvC,8CAA8C;EAC9C,uDAAuD;EACvD,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;iCACiC;AACjC;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA,uFAAuF;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA,+EAA+E;AAC/E;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA,+EAA+E;AAC/E;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;AACA;;EAEE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;;AAEA;gEACgE;AAChE;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;IAChC,0CAA0C;EAC5C;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;;IAGE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,6FAA6F;AAC/F;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,eAAe;EACf,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,4BAA4B;EAC5B,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,gDAAgD;EAChD,yCAAyC;EACzC,gDAAgD;EAChD,6BAA6B;EAC7B,oCAAoC;EACpC,gDAAgD;EAChD,uCAAuC;AACzC;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA,sEAAsE;AACtE;EACE,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sDAAsD;EACtD,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE;;IAEE,qCAAqC;EACvC;AACF;;AAEA,4DAA4D;AAC5D;EACE,0CAA0C;EAC1C,6CAA6C;EAC7C,0CAA0C;EAC1C,+BAA+B;EAC/B,uCAAuC;EACvC,2CAA2C;EAC3C,8CAA8C;EAC9C,8CAA8C;EAC9C,iCAAiC;EACjC,0CAA0C;EAC1C,4BAA4B;AAC9B","sourcesContent":["/*\n * Retema o Bootstrap 5 com os tokens SoftwarePlus — layout \"Razão\" (importar DEPOIS de\n * \"bootstrap/dist/css/bootstrap.min.css\" e de \"./nocturne-tokens.css\").\n * Troca as custom properties que o Bootstrap 5 já usa internamente (botões/forms/tabelas/modais\n * herdam a paleta sem CSS extra); as classes .nt-* cobrem o que não tem equivalente no Bootstrap\n * (casca, menu lateral, faixa de números, status, gráfico do painel, login).\n * Regras do layout: linhas finas no lugar de sombra, números em mono tabular, uma cor de ação\n * (verde conta) e cores de status reservadas — status sempre com texto, nunca só cor.\n */\n\n:root {\n  --bs-body-bg: var(--sp-ground);\n  --bs-body-color: var(--sp-ink);\n  --bs-body-font-family: var(--sp-font-sans);\n  --bs-body-font-size: 14px;\n  --bs-emphasis-color: var(--sp-ink);\n  --bs-secondary-color: var(--sp-ink-3);\n  --bs-tertiary-color: var(--sp-ink-2);\n  --bs-secondary-bg: var(--sp-rule-2);\n  --bs-tertiary-bg: var(--sp-sunk);\n\n  --bs-primary: var(--sp-accent);\n  --bs-primary-rgb: 14, 107, 85;\n  --bs-success-rgb: 22, 133, 106;\n  --bs-danger-rgb: 163, 36, 27;\n  --bs-secondary-rgb: 95, 105, 99;\n  --bs-link-color: var(--sp-accent);\n  --bs-link-hover-color: var(--sp-accent-hover);\n  --bs-link-color-rgb: 14, 107, 85;\n  --bs-link-hover-color-rgb: 10, 82, 66;\n\n  --bs-border-color: var(--sp-rule);\n  --bs-border-color-translucent: var(--sp-rule);\n  --bs-border-radius: var(--radius-sm);\n  --bs-border-radius-sm: var(--radius-sm);\n  --bs-border-radius-lg: var(--radius-md);\n  --bs-border-radius-xl: var(--radius-md);\n\n  --bs-focus-ring-color: rgba(14, 107, 85, 0.2);\n\n  color-scheme: light;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  font-family: var(--sp-font-sans);\n  font-size: 14px;\n  line-height: 1.45;\n  color: var(--sp-ink);\n  background: var(--sp-ground);\n  -webkit-font-smoothing: antialiased;\n}\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: var(--sp-font-sans);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--sp-ink);\n}\n:focus-visible {\n  outline: 2px solid var(--sp-accent);\n  outline-offset: 2px;\n}\n.text-secondary {\n  color: var(--sp-ink-3) !important;\n}\n.text-danger {\n  color: var(--sp-bad) !important;\n}\n.text-success {\n  color: var(--sp-ok) !important;\n}\n\n/* números tabulares em mono — todo valor monetário, data e código das telas */\n.nt-tabular,\n.nt-mono {\n  font-family: var(--sp-font-mono);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── botões ──\n   primário/sucesso = verde conta (ação e Salvar); perigo = vermelho (Cancelar e Excluir);\n   secundário = neutro branco com borda (ações de apoio). */\n.btn {\n  --bs-btn-font-family: var(--sp-font-sans);\n  --bs-btn-font-size: 13.5px;\n  --bs-btn-font-weight: 500;\n  --bs-btn-padding-x: 14px;\n  --bs-btn-padding-y: 8px;\n  --bs-btn-border-radius: var(--radius-sm);\n  --bs-btn-focus-box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.2);\n  white-space: nowrap;\n}\n.btn-sm {\n  --bs-btn-font-size: 12.5px;\n  --bs-btn-padding-x: 10px;\n  --bs-btn-padding-y: 5px;\n}\n.btn-lg {\n  --bs-btn-font-size: 14.5px;\n  --bs-btn-padding-y: 11px;\n}\n.btn-primary,\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: var(--sp-accent);\n  --bs-btn-border-color: var(--sp-accent);\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: var(--sp-accent-hover);\n  --bs-btn-hover-border-color: var(--sp-accent-hover);\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: var(--sp-accent-hover);\n  --bs-btn-active-border-color: var(--sp-accent-hover);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: var(--sp-accent);\n  --bs-btn-disabled-border-color: var(--sp-accent);\n}\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: var(--sp-bad);\n  --bs-btn-border-color: var(--sp-bad);\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: var(--sp-bad-hover);\n  --bs-btn-hover-border-color: var(--sp-bad-hover);\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: var(--sp-bad-hover);\n  --bs-btn-active-border-color: var(--sp-bad-hover);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: var(--sp-bad);\n  --bs-btn-disabled-border-color: var(--sp-bad);\n}\n.btn-secondary,\n.btn-outline-secondary,\n.btn-light,\n.btn-outline-dark {\n  --bs-btn-color: var(--sp-ink);\n  --bs-btn-bg: var(--sp-surface);\n  --bs-btn-border-color: var(--sp-rule);\n  --bs-btn-hover-color: var(--sp-ink);\n  --bs-btn-hover-bg: var(--sp-sunk);\n  --bs-btn-hover-border-color: #b6beb7;\n  --bs-btn-active-color: var(--sp-ink);\n  --bs-btn-active-bg: var(--sp-rule-2);\n  --bs-btn-active-border-color: #b6beb7;\n  --bs-btn-disabled-color: var(--sp-ink-3);\n  --bs-btn-disabled-bg: var(--sp-surface);\n  --bs-btn-disabled-border-color: var(--sp-rule);\n}\n.btn-ghost {\n  color: var(--sp-ink-2);\n  background: transparent;\n  border: 0;\n  padding-inline: var(--space-2);\n}\n.btn-ghost:hover {\n  background: var(--sp-rule-2);\n}\n\n/* ── formulários ── */\n.form-control,\n.form-select {\n  border-color: var(--sp-rule);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  color: var(--sp-ink);\n  min-height: 38px;\n}\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--sp-accent);\n  box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.15);\n}\n.form-control:disabled,\n.form-control[readonly],\n.form-select:disabled {\n  background-color: var(--sp-sunk);\n  color: var(--sp-ink-2);\n}\n.form-label,\n.nt-field-label {\n  font-size: 12.5px !important;\n  font-weight: 600 !important;\n  color: var(--sp-ink-2);\n}\n.nt-field-label {\n  display: block;\n  margin-bottom: 0.3rem;\n}\n.form-check-input:checked {\n  background-color: var(--sp-accent);\n  border-color: var(--sp-accent);\n}\n.form-check-input:focus {\n  border-color: var(--sp-accent);\n  box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.15);\n}\n.nav-link {\n  color: var(--sp-ink-2);\n}\n.nav-link:hover,\n.nav-link:focus {\n  color: var(--sp-ink);\n}\n.nav-tabs .nav-link.active {\n  color: var(--sp-ink);\n  font-weight: 600;\n}\n.nav-pills .nav-link.active {\n  background: var(--sp-ink);\n}\n\n/* ── controle segmentado (abas de relatório, filtros rápidos) ── */\n.nt-seg {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  padding: 3px;\n  border: 1px solid var(--sp-rule);\n  border-radius: var(--radius-sm);\n  background: var(--sp-surface);\n}\n.nt-seg button {\n  height: 32px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  font: inherit;\n  font-size: 13px;\n  color: var(--sp-ink-2);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.nt-seg button:hover {\n  background: var(--sp-sunk);\n}\n.nt-seg button.on {\n  background: var(--sp-ink);\n  color: #fff;\n}\n\n/* ── painéis / cards: borda fina, sem sombra ── */\n.card,\n.nt-card {\n  background: var(--sp-surface);\n  border: 1px solid var(--sp-rule);\n  border-radius: var(--radius-md);\n  box-shadow: none;\n}\n.nt-card-kicker {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--sp-ink-3);\n}\n.nt-card-title {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 1.25;\n  color: var(--sp-ink);\n}\n.nt-panel-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 12px;\n  padding: 13px 18px;\n  border-bottom: 1px solid var(--sp-rule-2);\n}\n.nt-panel-head h2 {\n  font-size: 14.5px;\n  margin: 0;\n}\n.nt-panel-head .nt-meta {\n  font-size: 12.5px;\n  color: var(--sp-ink-3);\n}\n.nt-panel-body {\n  padding: 16px 18px;\n}\n\n/* ── status: quadradinho de cor + texto (ver StatusTag.tsx) ── */\n.nt-st {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  white-space: nowrap;\n  color: var(--sp-ink);\n}\n.nt-st::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  background: var(--sp-mute);\n  flex: none;\n}\n.nt-st[data-tone=\"ok\"]::before {\n  background: var(--sp-ok);\n}\n.nt-st[data-tone=\"warn\"]::before {\n  background: var(--sp-warn);\n}\n.nt-st[data-tone=\"info\"]::before {\n  background: var(--sp-info);\n}\n.nt-st[data-tone=\"bad\"] {\n  color: var(--sp-bad);\n  font-weight: 500;\n}\n.nt-st[data-tone=\"bad\"]::before {\n  background: var(--sp-bad);\n}\n.nt-st[data-tone=\"off\"] {\n  color: var(--sp-ink-3);\n}\n.nt-tag {\n  display: inline-block;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--sp-rule-2);\n  color: var(--sp-ink-2);\n  white-space: nowrap;\n}\n\n/* ── tabelas: caixa branca com borda fina, cabeçalho claro, sem zebra, rolagem horizontal ── */\n.nt-table-wrap {\n  overflow-x: auto;\n  overflow-y: hidden;\n  background: var(--sp-surface);\n  border: 1px solid var(--sp-rule);\n  border-radius: var(--radius-md);\n}\n.nt-table-wrap table,\ntable.nt-table-fade,\ntable.nt-table {\n  margin-bottom: 0;\n  table-layout: fixed;\n  --bs-table-bg: transparent;\n  --bs-table-striped-bg: transparent;\n  --bs-table-hover-bg: #fafbf8;\n  --bs-table-color: var(--sp-ink);\n  --bs-table-striped-color: var(--sp-ink);\n  --bs-table-border-color: var(--sp-rule-2);\n}\n.nt-table thead th,\n.nt-table-fade thead th {\n  background: var(--sp-sunk);\n  color: var(--sp-ink-2);\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--sp-rule);\n  white-space: nowrap;\n}\n.nt-table thead th.text-end,\n.nt-table-fade thead th.text-end {\n  text-align: right;\n}\n.nt-table thead th.text-center,\n.nt-table-fade thead th.text-center {\n  text-align: center;\n}\n.nt-table tbody td,\n.nt-table-fade tbody td,\n.nt-table tfoot td,\n.nt-table-fade tfoot td {\n  text-align: left;\n  padding: 10px 14px;\n  font-size: 13.5px;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--sp-rule-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.nt-table tbody td.text-end,\n.nt-table-fade tbody td.text-end,\n.nt-table tfoot td.text-end,\n.nt-table-fade tfoot td.text-end {\n  text-align: right;\n}\n.nt-table tbody td.text-center,\n.nt-table-fade tbody td.text-center {\n  text-align: center;\n}\n/* coluna de ações (última): nunca corta os botões — quebra em linha se não couber */\n.nt-table tbody td:last-child,\n.nt-table-fade tbody td:last-child {\n  overflow: visible;\n}\n.nt-table tbody td:last-child > .d-flex,\n.nt-table-fade tbody td:last-child > .d-flex {\n  flex-wrap: wrap;\n  row-gap: 4px !important;\n}\n.nt-table tbody tr:last-child td,\n.nt-table-fade tbody tr:last-child td {\n  border-bottom: 0;\n}\n.nt-table tbody tr:hover > td,\n.nt-table-fade tbody tr:hover > td {\n  background: #fafbf8;\n}\n.nt-table tfoot td,\n.nt-table-fade tfoot td {\n  background: var(--sp-sunk);\n  font-weight: 600;\n  border-top: 1px solid var(--sp-rule);\n  border-bottom: 0;\n}\n.nt-table-fade tr.nt-row-late > td {\n  background: var(--sp-bad-soft);\n}\n.nt-sub {\n  display: block;\n  font-size: 12px;\n  color: var(--sp-ink-3);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.nt-code {\n  font-family: var(--sp-font-mono);\n  font-size: 12.5px;\n  color: var(--sp-ink-2);\n}\n\n/* ── paginação (react-paginate + .pagination nativo): botões separados, ativo em tinta ──\n   As custom properties precisam ser redeclaradas em \".pagination\" (o bootstrap.min.css já as\n   define direto na classe, e a declaração local vence a herdada de :root). */\n.pagination {\n  --bs-pagination-color: var(--sp-ink-2);\n  --bs-pagination-bg: var(--sp-surface);\n  --bs-pagination-border-color: var(--sp-rule);\n  --bs-pagination-border-radius: var(--radius-sm);\n  --bs-pagination-hover-bg: var(--sp-sunk);\n  --bs-pagination-hover-color: var(--sp-ink);\n  --bs-pagination-hover-border-color: #b6beb7;\n  --bs-pagination-focus-color: var(--sp-ink);\n  --bs-pagination-focus-bg: var(--sp-sunk);\n  --bs-pagination-focus-box-shadow: 0 0 0 3px rgba(14, 107, 85, 0.2);\n  --bs-pagination-active-bg: var(--sp-ink);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-border-color: var(--sp-ink);\n  --bs-pagination-disabled-color: #a9b0ab;\n  --bs-pagination-disabled-bg: var(--sp-surface);\n  --bs-pagination-disabled-border-color: var(--sp-rule-2);\n  gap: 4px;\n  flex-wrap: wrap;\n}\n.pagination .page-link {\n  min-width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  padding: 0 9px;\n  margin-left: 0 !important;\n  border-radius: var(--radius-sm) !important;\n  font-family: var(--sp-font-mono);\n  font-size: 12.5px;\n  cursor: pointer;\n}\n.nt-pag {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--sp-ink-3);\n}\n\n/* ── casca: menu lateral + conteúdo ── */\n.nt-app {\n  display: flex;\n  height: 100vh;\n  background: var(--sp-ground);\n}\n.nt-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.nt-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.nt-wrap {\n  padding: 28px 32px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  width: 100%;\n  max-width: 1400px;\n}\n.nt-page-head h1 {\n  font-size: 24px;\n  line-height: 1.2;\n  margin: 0;\n}\n.nt-page-head p {\n  margin: 4px 0 0;\n  color: var(--sp-ink-3);\n  font-size: 13.5px;\n  max-width: 70ch;\n}\n\n/* a largura anima entre 236px e 0 (desktop recolhido); o miolo tem largura fixa pra o texto não\n   quebrar durante a transição. */\n.nt-sidebar {\n  flex: none;\n  width: 236px;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var(--sp-side);\n  color: var(--sp-side-ink);\n  transition: width 0.25s ease;\n}\n.nt-sidebar.collapsed {\n  width: 0;\n}\n.nt-sidebar-inner {\n  width: 236px;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 18px 0 14px;\n}\n.nt-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 20px 18px;\n  border-bottom: 1px solid var(--sp-side-line);\n  color: #fff;\n}\n.nt-brand strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n.nt-brand small {\n  display: block;\n  font-size: 12px;\n  color: var(--sp-side-muted);\n}\n.nt-mark {\n  width: 34px;\n  height: 34px;\n  border-radius: 7px;\n  background: var(--sp-accent);\n  color: #fff;\n  font-family: var(--sp-font-mono);\n  font-weight: 500;\n  font-size: 13px;\n  display: grid;\n  place-items: center;\n  flex: none;\n}\n.nt-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 16px 12px;\n  flex: 1;\n}\n.nt-nav-group {\n  display: flex;\n  flex-direction: column;\n}\n/* cabeçalho clicável do grupo (Cadastros, Financeiro, Sistema) — abre/fecha os itens */\n.nt-nav-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 38px;\n  padding: 0 10px;\n  border: 0;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--sp-side-ink);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n}\n.nt-nav-toggle:hover,\n.nt-nav-toggle[aria-expanded=\"true\"] {\n  background: var(--sp-side-2);\n  color: #fff;\n}\n.nt-nav-toggle .bi {\n  font-size: 11px;\n  color: var(--sp-side-muted);\n}\n/* grupo fechado que contém a tela atual: um ponto verde avisa onde você está */\n.nt-nav-toggle.has-active[aria-expanded=\"false\"] span::after {\n  content: \"\";\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--sp-ok);\n  margin-left: 8px;\n  vertical-align: middle;\n}\n.nt-nav-items {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 4px 0 8px 10px;\n  margin-left: 10px;\n  border-left: 1px solid var(--sp-side-line);\n}\n.nt-nav-top {\n  font-weight: 600;\n}\n.nt-nav-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 36px;\n  padding: 0 10px;\n  border-radius: var(--radius-sm);\n  color: var(--sp-side-ink);\n  text-decoration: none;\n  font-size: 13.5px;\n}\n.nt-nav-item:hover {\n  background: var(--sp-side-2);\n  color: #fff;\n}\n/* item ativo na cor do fundo da página: parece uma aba encaixada no conteúdo */\n.nt-nav-item.active {\n  background: var(--sp-ground);\n  color: var(--sp-ink);\n  font-weight: 600;\n}\n.nt-me {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 12px;\n  padding: 12px 8px 0;\n  border-top: 1px solid var(--sp-side-line);\n}\n.nt-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #2c3a33;\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex: none;\n}\n.nt-me strong {\n  display: block;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n.nt-me small {\n  display: block;\n  font-size: 11.5px;\n  color: var(--sp-side-muted);\n}\n.nt-me-out,\n.nt-side-close {\n  margin-left: auto;\n  color: var(--sp-side-ink);\n  background: transparent;\n  border: 0;\n  font-size: 12.5px;\n  padding: 8px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n.nt-me-out:hover,\n.nt-side-close:hover {\n  background: var(--sp-side-2);\n  color: #fff;\n}\n.nt-side-close {\n  display: none;\n  width: 44px;\n  height: 44px;\n  font-size: 18px;\n}\n.nt-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 18, 14, 0.5);\n  z-index: 1040;\n}\n\n.nt-topbar {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 12px 20px;\n  min-height: 56px;\n  padding: 10px 32px;\n  border-bottom: 1px solid var(--sp-rule);\n  background: var(--sp-surface);\n}\n.nt-crumb {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-size: 13px;\n  color: var(--sp-ink-3);\n  min-width: 0;\n}\n.nt-crumb strong {\n  color: var(--sp-ink);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.nt-today {\n  margin-left: auto;\n  font-family: var(--sp-font-mono);\n  font-size: 12.5px;\n  color: var(--sp-ink-3);\n}\n.nt-burger {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border: 0;\n  background: transparent;\n  color: var(--sp-ink);\n  font-size: 22px;\n  border-radius: var(--radius-sm);\n  margin-left: -12px;\n  flex: none;\n}\n.nt-burger:hover {\n  background: var(--sp-rule-2);\n}\n\n/* abaixo de 768px: menu sai do fluxo e vira gaveta por cima da tela (fecha ao navegar, ver\n   AppShell); a barra do topo fica escura com o botão de menu. */\n@media (max-width: 767.98px) {\n  .nt-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 290px;\n    z-index: 1045;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease;\n    box-shadow: 12px 0 40px rgba(0, 0, 0, 0.3);\n  }\n  .nt-sidebar.open {\n    transform: none;\n  }\n  .nt-sidebar-inner {\n    width: 290px;\n    padding-top: 12px;\n  }\n  .nt-nav-toggle {\n    min-height: 44px;\n  }\n  .nt-brand {\n    padding: 0 8px 12px 20px;\n  }\n  .nt-side-close {\n    display: grid;\n    place-items: center;\n  }\n  .nt-nav-item {\n    min-height: 44px;\n  }\n  .nt-topbar {\n    background: var(--sp-side);\n    border-bottom: 0;\n    padding: 6px 12px;\n    color: #fff;\n  }\n  .nt-burger {\n    color: #fff;\n    width: 44px;\n    height: 44px;\n    margin-left: -6px;\n  }\n  .nt-burger:hover {\n    background: var(--sp-side-2);\n  }\n  .nt-crumb {\n    color: #fff;\n    font-size: 16px;\n  }\n  .nt-crumb strong {\n    color: #fff;\n  }\n  .nt-crumb-group,\n  .nt-crumb-sep,\n  .nt-today {\n    display: none;\n  }\n  .nt-wrap {\n    padding: 18px 16px 32px;\n  }\n  .nt-page-head h1 {\n    font-size: 21px;\n  }\n}\n\n/* ── faixa de números (painel e topo das telas) ── */\n.nt-figs {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  background: var(--sp-surface);\n  border: 1px solid var(--sp-rule);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n.nt-fig {\n  padding: 15px 20px;\n  border-left: 1px solid var(--sp-rule-2);\n  margin-left: -1px;\n  border-top: 1px solid var(--sp-rule-2);\n  margin-top: -1px;\n}\n.nt-fig-label {\n  font-size: 12.5px;\n  color: var(--sp-ink-3);\n}\n.nt-fig-value {\n  font-family: var(--sp-font-mono);\n  font-variant-numeric: tabular-nums;\n  font-size: 22px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  margin-top: 3px;\n}\n.nt-fig-value.bad {\n  color: var(--sp-bad);\n}\n.nt-fig-note {\n  font-size: 12px;\n  color: var(--sp-ink-3);\n  margin-top: 1px;\n}\n\n/* ── gráfico de barras agrupadas do painel (recebido x pago) ── */\n.nt-legend {\n  display: flex;\n  gap: 14px;\n  font-size: 12.5px;\n  color: var(--sp-ink-2);\n}\n.nt-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.nt-legend i {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  display: inline-block;\n}\n.nt-chart {\n  display: grid;\n  grid-template-columns: 56px minmax(0, 1fr);\n  column-gap: 10px;\n}\n.nt-chart-y {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 200px;\n  margin: -7px 0;\n  font-family: var(--sp-font-mono);\n  font-size: 11px;\n  color: var(--sp-ink-3);\n  text-align: right;\n}\n.nt-chart-plot {\n  height: 200px;\n  display: grid;\n  align-items: end;\n  border-bottom: 1px solid var(--sp-ink-3);\n  background: repeating-linear-gradient(to top, transparent 0 49px, var(--sp-rule-2) 49px 50px);\n}\n.nt-chart-group {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 2px;\n  height: 100%;\n}\n.nt-chart-bar {\n  width: 22px;\n  max-width: 30%;\n  border-radius: 4px 4px 0 0;\n  min-height: 1px;\n}\n.nt-chart-x {\n  grid-column: 2;\n  display: grid;\n  font-size: 12px;\n  color: var(--sp-ink-3);\n  text-align: center;\n  padding-top: 7px;\n}\n.nt-hbar {\n  display: grid;\n  grid-template-columns: minmax(0, 170px) minmax(0, 1fr) 110px;\n  align-items: center;\n  gap: 12px;\n  font-size: 13.5px;\n  padding: 7px 0;\n}\n.nt-hbar-track {\n  height: 8px;\n  border-radius: 4px;\n  background: var(--sp-rule-2);\n  overflow: hidden;\n}\n.nt-hbar-track i {\n  display: block;\n  height: 8px;\n  border-radius: 4px;\n  background: var(--sp-accent);\n}\n.nt-list-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--sp-rule-2);\n}\n.nt-list-row:last-child {\n  border-bottom: 0;\n}\n.nt-day {\n  font-family: var(--sp-font-mono);\n  font-size: 12px;\n  color: var(--sp-ink-3);\n  width: 52px;\n  flex: none;\n  line-height: 1.25;\n}\n.nt-day strong {\n  display: block;\n  font-size: 17px;\n  color: var(--sp-ink);\n  font-weight: 500;\n}\n@media (max-width: 560px) {\n  .nt-hbar {\n    grid-template-columns: minmax(0, 1fr) 100px;\n  }\n  .nt-hbar-track {\n    grid-column: 1 / -1;\n    grid-row: 2;\n  }\n}\n\n/* ── login: painel escuro + formulário ── */\n.nt-login {\n  display: flex;\n  flex-wrap: wrap;\n  min-height: 100vh;\n  background: var(--sp-ground);\n}\n.nt-login-side {\n  flex: 1 1 440px;\n  background: var(--sp-side);\n  color: var(--sp-side-ink);\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 48px;\n}\n.nt-login-side .nt-brand {\n  padding: 0;\n  border-bottom: 0;\n}\n.nt-login-side h1 {\n  color: #fff;\n  font-size: 34px;\n  line-height: 1.15;\n  max-width: 15ch;\n  letter-spacing: -0.02em;\n  margin: 0;\n}\n.nt-ledger {\n  border-top: 1px solid var(--sp-side-line);\n  max-width: 440px;\n}\n.nt-ledger div {\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr);\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--sp-side-line);\n  font-size: 13.5px;\n}\n.nt-ledger b {\n  font-family: var(--sp-font-mono);\n  font-size: 12.5px;\n  color: #fff;\n  font-weight: 500;\n}\n.nt-login-foot {\n  font-size: 12px;\n  color: var(--sp-side-muted);\n}\n.nt-login-main {\n  flex: 1 1 420px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n}\n.nt-login-card {\n  width: 100%;\n  max-width: 380px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.nt-login-card .form-control {\n  min-height: 44px;\n}\n@media (max-width: 767.98px) {\n  .nt-login-side {\n    padding: 28px 20px 26px;\n    gap: 22px;\n  }\n  .nt-login-side h1 {\n    font-size: 24px;\n  }\n  .nt-ledger,\n  .nt-login-foot {\n    display: none;\n  }\n  .nt-login-main {\n    align-items: flex-start;\n    padding: 26px 20px;\n  }\n}\n\n/* ── toast ── */\n@keyframes nt-rise-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n.nt-toast {\n  position: fixed;\n  top: 12px;\n  right: 12px;\n  width: min(340px, calc(100vw - 24px));\n  padding: 13px 16px;\n  border-radius: var(--radius-md);\n  background: var(--sp-ink);\n  color: #fff;\n  box-shadow: var(--shadow-md);\n  font-size: 13.5px;\n  animation: nt-rise-in 200ms ease-out;\n  z-index: 1080;\n}\n.nt-toast-mark {\n  display: none;\n}\n\n/* ── modais centralizadas (react-bootstrap Modal) ── */\n.modal {\n  --bs-modal-bg: var(--sp-surface);\n  --bs-modal-color: var(--sp-ink);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: var(--radius-lg);\n  --bs-modal-inner-border-radius: var(--radius-lg);\n  --bs-modal-header-padding: 18px 22px 14px;\n  --bs-modal-header-border-color: var(--sp-rule-2);\n  --bs-modal-padding: 18px 22px;\n  --bs-modal-footer-bg: var(--sp-sunk);\n  --bs-modal-footer-border-color: var(--sp-rule-2);\n  --bs-modal-box-shadow: var(--shadow-lg);\n}\n.modal-backdrop {\n  --bs-backdrop-bg: #15201b;\n  --bs-backdrop-opacity: 0.55;\n}\n.modal-content {\n  box-shadow: var(--shadow-lg);\n  padding: 0 !important;\n}\n.modal-title {\n  font-family: var(--sp-font-sans) !important;\n  font-size: 18px !important;\n  font-weight: 600;\n}\n.modal-footer {\n  gap: 8px;\n  padding: 13px 22px;\n}\n.modal-footer > * {\n  margin: 0;\n}\n/* o cabeçalho é claro: o X \"white\" (closeVariant) ficaria invisível */\n.modal .btn-close-white {\n  filter: none;\n}\n.nt-dialog .modal-content {\n  animation: nt-rise-in 180ms ease-out;\n}\n\n/* ── grids de 2 colunas (painel, relatórios) empilham em telas estreitas ── */\n.nt-grid-2 {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);\n  align-items: start;\n}\n.nt-grid-2-even {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  align-items: start;\n}\n@media (max-width: 1020px) {\n  .nt-grid-2,\n  .nt-grid-2-even {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ── menu suspenso (ex.: \"Ações\" da linha de contrato) ── */\n.dropdown-menu {\n  --bs-dropdown-border-color: var(--sp-rule);\n  --bs-dropdown-border-radius: var(--radius-md);\n  --bs-dropdown-box-shadow: var(--shadow-md);\n  --bs-dropdown-font-size: 13.5px;\n  --bs-dropdown-link-color: var(--sp-ink);\n  --bs-dropdown-link-hover-bg: var(--sp-sunk);\n  --bs-dropdown-link-active-bg: var(--sp-rule-2);\n  --bs-dropdown-link-active-color: var(--sp-ink);\n  --bs-dropdown-item-padding-y: 7px;\n  --bs-dropdown-divider-bg: var(--sp-rule-2);\n  box-shadow: var(--shadow-md);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
